/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_View_BoardInputs */

const en_directory_promotion_view_board = /** @type {(inputs: Directory_Promotion_View_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View VibeBids board`)
};

const zh_directory_promotion_view_board = /** @type {(inputs: Directory_Promotion_View_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看 VibeBids 榜单`)
};

/**
* | output |
* | --- |
* | "View VibeBids board" |
*
* @param {Directory_Promotion_View_BoardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_view_board = /** @type {((inputs?: Directory_Promotion_View_BoardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_View_BoardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_view_board(inputs)
	return zh_directory_promotion_view_board(inputs)
});
export { directory_promotion_view_board as "directory.promotion.view_board" }